import React from "react";

import SystemStatusTable from "../../sub-pages/elements/SystemStatusTable";

import { IconClock, IconHistory, IconBrandWordpress, IconCode, IconPlug, IconPalette } from "@tabler/icons-react";

const softwareItems = [
    {
        name: "WordPress",
        icon: <IconBrandWordpress size={30} color="var(--bs-primary)" />,
        current: "5.5",
        currentTitle: "Current Version",
        recommended: "7.2",
        recommendedTitle: "Recommended Version",
        badge: "Check This!",
    },
    {
        name: "Plugins",
        icon: <IconPlug size={30} color="var(--bs-success)" />,
        current: "10",
        currentTitle: "Installed",
        recommended: "3",
        recommendedTitle: "Recommended Update",
        badge: "Check This!",
    },
];

const Plugins = (props) => {
    return <>
        <SystemStatusTable systemItems={null} softwareItems={softwareItems} />
    </>
}

export default Plugins;
